import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import ReactToPrint from 'react-to-print';
import {RESOURCES as reportsResources} from '../fuseDiscountsReportsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import {displayDateRangeString, toCurrency} from '../shared/functions';
import {
    createTableRow,
    populateCustomerUsageTable,
    populateDiscountListTable,
} from '../shared/reportTableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import DiscountsListTable from './DiscountsListTable';
import DiscountsVipCostumerTable from './DiscountsVipCostumerTable';
import LocationDiscountsTotalsTable from './LocationDiscountsTotalsTable';
import Config from '../messages';
import '../shared/react-table.css';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';

/**
 * Class for retrieving and displaying Discounts data for multiple tables
 *
 */
class DiscountsReportSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowLocationSelection: true,
            allowLoyaltySelection: true,
            allowProductSelection: true,
            countType: null,
            countValid: true,
            countValue: {
                id1: null,
                id2: null
            },
            dataIsFiltered: false,
            dataSet1Complete: false,
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,
            headerSet1: {
                type: null,
                choice: null
            },
            headerSet2: {
                dba: {
                    name: null
                },
                id: null,
                name: null,
                city: null,
                state: null
            },
            headerSet3: {
                id: null,
                first_name: null,
                last_name: null,
                email: null,
                telephone: null,
                city: null,
                state: null,
                zip: null
            },
            loadingData1: props.showLoading,
            loadingData2: false,
            loadingData3: false,
            selectedLocation: {
                id: null,
                name: null,
                dba_name: null,
                city: null,
                selected: false,
                state: null,
                type: null,
                zipcode: null
            },
            selectedLoyalty: {
                first_name: null,
                id: null,
                last_name: null,
                city: null,
                state: null,
                zip: null
            },
            tableSet1Discounts: [],
            tableSet1Locations: [],
            tableSet2Customers: [],
            tableSet2Discounts: [],
            tableSet3Discounts: [],
        };
        this.area2Position = null;
        this.area3Position = null;
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleLoyaltySelect = this.handleLoyaltySelect.bind(this);
    }

    componentWillMount() {
        this.setDataForFetch('all_count');
    }

    componentWillReceiveProps(nextProps) {
        let clearData = false;
        // If initial date range or filter choices change, reset
        if (
            nextProps.startDate !== this.props.startDate ||
            nextProps.endDate !== this.props.endDate ||
            nextProps.offset !== this.props.offset ||
            nextProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            nextProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            nextProps.filterType !== this.props.filterType ||
            nextProps.showLoading !== this.props.showLoading
        ) {
            clearData = true;
        }
        if (clearData) {
            this.setState({
                allowLocationSelection: true,
                allowLoyaltySelection: true,
                dataSet1Complete: false,
                errorMessage1: null,
                errorMessage2: null,
                errorMessage3: null,
                loadingData1: nextProps.showLoading,
                loadingData2: false,
                loadingData3: false,
                selectedLocation: {
                    id: null,
                    name: null,
                    dba_name: null,
                    city: null,
                    selected: false,
                    state: null,
                    type: null,
                    zipcode: null
                },
                selectedLoyalty: {
                    first_name: null,
                    id: null,
                    last_name: null,
                    city: null,
                    state: null,
                    zip: null
                },
                tableSet1Discounts: [],
                tableSet1Locations: [],
                tableSet2Customers: [],
                tableSet2Discounts: [],
                tableSet3Discounts: [],
            });
        }
    }

    componentDidUpdate(prevProps) {
        let dataTypeToFetch = 'none';
        if (
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate ||
            prevProps.offset !== this.props.offset ||
            (prevProps.filterType !== 'all' && this.props.filterType === 'all')
        ) {
            dataTypeToFetch = 'all';
        }
        if (
            prevProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            prevProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            prevProps.totalFiltersAvailable !== this.props.totalFiltersAvailable
        ) {
            if (this.props.totalFiltersAvailable === 2) {
                dataTypeToFetch = (this.props.filterChoiceSecond) ? 'filter' : 'none';
            } else if (this.props.totalFiltersAvailable === 1) {
                dataTypeToFetch = 'filter';
            }
        }
        if (dataTypeToFetch === 'filter') {
            this.setDataForFetch(prevProps.filterType + '_count');
        } else if (dataTypeToFetch === 'all') {
            this.setDataForFetch('all_count');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Set up call for data by a specific date range
     *
     * @param dataType
     * @param selectedValue
     */
    setDataForFetch(dataType, selectedValue = null) {
        const params = {
            start_date: this.props.startDate,
            end_date: this.props.endDate,
            offset: this.props.offset,
        };

        // Update parameters and set resource based on data filter
        let resource;
        let reportName = 'Discounts';

        let firstFilterValue, secondFilterValue;
        if (dataType !== 'all') {
            if (this.props.filterChoiceFirst) {
                firstFilterValue = this.props.filterChoiceFirst;
            }
            if (this.props.filterChoiceSecond) {
                secondFilterValue = this.props.filterChoiceSecond;
            }
        }
        let dataIsFiltered = (dataType !== 'all');
        let locationId = (this.state.selectedLocation && this.state.selectedLocation.id) ? this.state.selectedLocation.id : null;
        let loyaltyId = (this.state.selectedLoyalty && this.state.selectedLoyalty.id) ? this.state.selectedLoyalty.id : null;
        let countType = null;
        let countValue = {
            id1: null,
            id2: null
        };

        let id = null;

        // Set additional params and select API path based on data type
        // All Discounts API calls require a call for count totals before data retrieval
        switch (dataType) {
            case 'statecity_count' :
                // Retrieve totals before calling for data by Filter: State and City
                countType = 'statecity';
                countValue.id1 = firstFilterValue;
                countValue.id2 = secondFilterValue;
                params.state = firstFilterValue;
                params.city = secondFilterValue;
                resource = reportsResources.DiscountsSalesCountByStateCity.GET_LIST(params);
                reportName = 'Discounts by State and City';
                break;
            case 'statecity':
                // Filter: State and City
                params.state = firstFilterValue;
                params.city = secondFilterValue;
                resource = reportsResources.DiscountsSalesByStateCity.GET_LIST(params);
                reportName = 'Discounts by State and City';
                break;
            case 'statedba_count' :
                // Retrieve totals before calling for data by Filter: State and DBA
                countType = 'statedba';
                countValue.id1 = firstFilterValue;
                countValue.id2 = secondFilterValue;
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = reportsResources.DiscountsSalesCountByStateDba.GET_LIST(params);
                reportName = 'Discounts by State and DBA';
                break;
            case 'statedba':
                // Filter: State and DBA
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = reportsResources.DiscountsSalesByStateDba.GET_LIST(params);
                reportName = 'Discounts by State and DBA';
                break;
            case 'dba_count' :
                // Retrieve totals before calling for data by Filter: DBA
                countType = 'dba';
                countValue.id1 = firstFilterValue;
                params.dba_id = firstFilterValue;
                resource = reportsResources.DiscountsSalesCountByDba.GET_LIST(params);
                reportName = 'Discounts by DBA';
                break;
            case 'dba':
                // Filter: DBA
                params.dba_id = firstFilterValue;
                resource = reportsResources.DiscountsSalesByDba.GET_LIST(params);
                reportName = 'Discounts by DBA';
                break;
            case 'district_count' :
                // Retrieve totals before calling for data by Filter: District
                countType = 'district';
                countValue.id1 = firstFilterValue;
                params.district_id = firstFilterValue;
                resource = reportsResources.DiscountsSalesCountByDistrict.GET_LIST(params);
                reportName = 'Discounts by District';
                break;
            case 'district':
                // Filter: District
                params.district_id = firstFilterValue;
                resource = reportsResources.DiscountsSalesByDistrict.GET_LIST(params);
                reportName = 'Discounts by District';
                break;
            case 'location_count' :
                // Retrieve totals before calling for data by Filter: Location
                countType = 'location';
                countValue.id1 = firstFilterValue;
                params.location_id = (firstFilterValue) ? firstFilterValue : locationId;
                resource = reportsResources.DiscountsSalesCountByLocation.GET_LIST(params);
                reportName = 'Discounts by Location ' + firstFilterValue;
                break;
            case 'location':
                // Filter: Location
                params.location_id = firstFilterValue;
                resource = reportsResources.DiscountsSalesByLocation.GET_LIST(params);
                reportName = 'Discounts by Location ' + firstFilterValue;
                break;
            case 'selected_location_count':
                // Retrieve totals before calling for data by selected Location
                countType = 'location';
                id = locationId;
                countValue.id1 = this.state.selectedLocation.id;
                params.location_id = this.state.selectedLocation.id;
                resource = reportsResources.DiscountsSalesCountByLocation.GET_LIST(params);
                reportName = 'Discounts by selected Location ' + this.state.selectedLocation.id;
                break;
            case 'selected_location':
                // Select Location ID in area 1: Retrieve data
                id = locationId;
                params.location_id = locationId;
                resource = reportsResources.DiscountsSalesByLocation.GET_LIST(params);
                reportName = 'Discounts by selected Location ' + locationId;
                break;
            case 'selected_loyalty_count':
                // Retrieve totals before calling for data by selected Loyalty
                countType = 'loyalty';
                id = loyaltyId;
                countValue.id1 = this.state.selectedLoyalty.id;
                params.loyalty_id = this.state.selectedLoyalty.id;
                resource = reportsResources.DiscountsSalesCountByLoyaltyAccount.GET_LIST(params);
                reportName = 'Discounts by Loyalty Account ' + this.state.selectedLoyalty.id;
                break;
            case 'selected_loyalty':
                // Select Loyalty ID in area 2: Retrieve data
                id = loyaltyId;
                params.loyalty_id = loyaltyId;
                resource = reportsResources.DiscountsSalesByLoyaltyAccount.GET_LIST(params);
                reportName = 'Discounts by Loyalty Account ' + loyaltyId;
                break;
            case 'state_count' :
                // Retrieve totals before calling for data by Filter: State
                countType = 'state';
                countValue.id1 = firstFilterValue;
                params.state = firstFilterValue;
                resource = reportsResources.DiscountsSalesCountByState.GET_LIST(params);
                reportName = 'Discounts by State';
                break;
            case 'state':
                // Filter: State
                params.state = firstFilterValue;
                resource = reportsResources.DiscountsSalesByState.GET_LIST(params);
                reportName = 'Discounts by State';
                break;
            case 'all_count' :
                // Retrieve totals before calling for all data
                countType = 'all';
                resource = reportsResources.DiscountsCountByDateRange.GET_LIST(params);
                break;
            case 'all':
                // Filter: All
                resource = reportsResources.DiscountsSalesAll.GET_LIST(params);
                break;
            default:
                // Get all data
                resource = reportsResources.DiscountsSalesAll.GET_LIST(params);
                break;
        }

        // If the request requires a count check, store the requested data before calling
        if (dataType.indexOf('_count') !== -1) {
            this.setState({
                countType: countType,
                countValid: true,
                countValue: {
                    id1: countValue.id1,
                    id2: countValue.id2
                },
            }, () => {
                let countSettings = {
                    countType: countType,
                    countValue: {
                        id1: countValue.id1,
                        id2: countValue.id2
                    }
                };
                this.fetchData(dataType, resource.uri, reportName, countSettings, dataIsFiltered, id);
            });
        } else {
            this.fetchData(dataType, resource.uri, reportName, null, dataIsFiltered, id);
        }
    }

    /**
     * Get filtered data by a specific date range
     *
     * @param dataType
     * @param resourceURI
     * @param reportName
     * @param countSettings
     * @param dataIsFiltered
     * @param id
     */
    fetchData(dataType, resourceURI, reportName, countSettings, dataIsFiltered, id) {

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resourceURI,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                if (dataType.indexOf('_count') !== -1) {
                    // Locations may be filtered or selected
                    let isSelected = false;
                    if (
                        dataType === 'location_count' && this.state.selectedLocation.type === 'selected'
                    ) {
                        isSelected = true;
                    } else if (dataType === 'selected_loyalty_count') {
                        isSelected = true;
                    }

                    // Check totals for requested API before retrieving data
                    this.checkCount(countSettings.countType, countSettings.countValue.id1, countSettings.countValue.id2, isSelected, result.data.payload);

                } else if (dataType === 'selected_location') {
                    // Process results for a selected Location ID
                    this.processLocationData(id, result.data.payload);

                } else if (dataType === 'selected_loyalty') {
                    // Process results for a selected Loyalty ID
                    this.processLoyaltyData(id, result.data.payload);

                } else {
                    // Process results for date range with optional filter
                    this.processData(dataType, dataIsFiltered, result.data.payload);
                }
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + reportName + '.';
            let errorMessage1 = (this.state.errorMessage1) ? this.state.errorMessage1 : null;
            let errorMessage2 = (this.state.errorMessage2) ? this.state.errorMessage2 : null;
            let errorMessage3 = (this.state.errorMessage3) ? this.state.errorMessage3 : null;
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + this.state.reportName + ': ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            if (dataType === 'selected_loyalty') {
                errorMessage3 = message;
            } else if (dataType === 'selected_location') {
                errorMessage2 = message;
            } else {
                errorMessage1 = message;
            }
            this.setState({
                errorMessage1: errorMessage1,
                errorMessage2: errorMessage2,
                errorMessage3: errorMessage3,
                loadingData1: false,
                loadingData2: false,
                loadingData3: false
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Check Location result totals before retrieving data for selected or filtered Location
     *
     * @param type
     * @param id1
     * @param id2
     * @param isSelected
     * @param data
     */
    checkCount(type, id1, id2, isSelected, data) {
        let countValid = true;
        let aggs = data.aggregations;
        if (aggs) {
            let discount_count = (
                aggs.discounts &&
                aggs.discounts.discount_count &&
                aggs.discounts.discount_count.value
            )
                ? aggs.discounts.discount_count.value : 0;
            let loyalty_count = (
                aggs.loyalty_count &&
                aggs.loyalty_count.value
            )
                ? aggs.loyalty_count.value : 0;
            let products_sold = (
                aggs.products_sold &&
                aggs.products_sold.products_sold_count &&
                aggs.products_sold.products_sold_count.value
            )
                ? aggs.products_sold.products_sold_count.value : 0;

            // If any result count would pass 10k, prevent the call
            if (discount_count > 9999 || products_sold > 9999 || loyalty_count > 9999) {
                countValid = false;
            }
        }
        // Store the value and proceed if applicable
        this.setState({
            countValid: countValid
        }, () => {
            // If the count is valid, proceed with the original call
            if (countValid) {
                // Locations and Loyalty might be selected instead of filtered
                if (isSelected) {
                    if (type === 'location') {
                        this.setDataForFetch('selected_location', id1);
                    } else if (type === 'loyalty') {
                        this.setDataForFetch('selected_loyalty', id1);
                    }
                } else {
                    this.setDataForFetch(type);
                }
            }
        });
    }

    /**
     * Process API results of Locations and Categories by Date Range (Table Set 1)
     *
     * @param dataType
     * @param dataIsFiltered
     * @param data
     */
    processData(dataType, dataIsFiltered, data) {

        // Create empty arrays for first table set
        let headerSet1 = {
            type: null,
            choice: null
        };
        let tableSet1Locations = [];
        let tableSet1Discounts = [];
        const emptyCurrency = toCurrency(0);

        if (data.aggregations) {

            // Assemble filtered data for each Location row in Area 1: Discounts Locations
            if (data.aggregations.totals_by_location && data.aggregations.totals_by_location.buckets) {
                let lResults = data.aggregations.totals_by_location.buckets;
                let lTotal = lResults.length;
                if (lTotal) {
                    for (let i = 0; i < lTotal; i++) {
                        let lResult = lResults[i];
                        let discountLocation = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                        discountLocation.id = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.client.location;
                        let totalAmountDiscounted = emptyCurrency;
                        let discountQty = 0;

                        if (lResult.discounts && lResult.discounts.discount_total) {
                            totalAmountDiscounted = lResult.discounts.discount_total.value;
                        }

                        if (lResult.discounts && lResult.discounts.discount_qty) {
                            discountQty = lResult.discounts.discount_qty.value;
                        }

                        // Create a Location row
                        let locationRow = createTableRow('discount_location', discountLocation);
                        locationRow.discount_total = (totalAmountDiscounted) ? toCurrency(totalAmountDiscounted, true) : emptyCurrency;
                        locationRow.discount_qty = (discountQty) ? discountQty : 0;

                        // Add the row to the table
                        tableSet1Locations.push(locationRow);
                    }
                }
            }

            // Assemble filtered data for Area 1: Discounts List
            tableSet1Discounts = populateDiscountListTable(data, this.props.offset);

            // If data is filtered by Location, store a single Location result
            if (dataType === 'location' && data.aggregations.column_name) {
                let aggs = data.aggregations;
                let location = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                location.id = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload.client.location;
                let totalAmountDiscounted = emptyCurrency;
                let discountQty = 0;

                if (aggs.discounts && aggs.discounts.discount_total) {
                    totalAmountDiscounted = aggs.discounts.discount_total.value;
                }

                if (aggs.discounts && aggs.discounts.discount_qty) {
                    discountQty = aggs.discounts.discount_qty.value;
                }

                // Create a Location row
                let locationRow = createTableRow('discount_location', location);
                locationRow.discount_total = (totalAmountDiscounted) ? toCurrency(totalAmountDiscounted, true) : emptyCurrency;
                locationRow.discount_qty = (discountQty) ? discountQty : 0;

                // Add the row to the table
                tableSet1Locations.push(locationRow);
            }

            // Store data for the Area header for this table set
            if (dataIsFiltered && data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    // Set the header based on filter selection, if applicable
                    switch (dataType) {
                        case 'statecity':
                            headerSet1.type = 'City and State';
                            headerSet1.choice = loc.city + ', ' + loc.state;
                            break;
                        case 'statedba':
                            headerSet1.type = 'DBA and State';
                            headerSet1.choice = loc.dba.name + ', ' + loc.state;
                            break;
                        case 'dba':
                            headerSet1.type = 'DBA';
                            headerSet1.choice = loc.dba.name + ' (' + loc.dba.id + ')';
                            break;
                        case 'district':
                            headerSet1.type = 'District';
                            headerSet1.choice = loc.district.name + ' (' + loc.district.id + ')';
                            break;
                        case 'location':
                            headerSet1.type = 'Location';
                            headerSet1.choice = loc.name + ' (' + dataPayload.client.location + ')';
                            break;
                        case 'state':
                            headerSet1.type = 'State';
                            headerSet1.choice = loc.state;
                            break;
                        default:
                            break;
                    }
                }
            }

            // Finalize API data and Points/Location table data
            this.setState({
                dataSet1Complete: true,
                errorMessage1: null,
                headerSet1: {
                    type: headerSet1.type,
                    choice: headerSet1.choice
                },
                loadingData1: false,
                tableSet1Locations: tableSet1Locations,
                tableSet1Discounts: tableSet1Discounts,
            }, () => {
                this.props.onDataProcessed();
            });
        }
    }

    /**
     * Process API results of Loyalty Accounts, Locations and Products by selected Location in Date Range (Table Set 2)
     *
     * @param id
     * @param data
     */
    processLoyaltyData(id, data) {
        // Create empty arrays for selected Location ID
        let headerSet3 = {
            id: null,
            first_name: null,
            last_name: null,
            email: null,
            telephone: null,
            city: null,
            state: null,
            zip: null
        };

        let tableSet3Discounts = [];

        if (data.aggregations) {
            // Assemble filtered data for Area 1: Discounts List
            tableSet3Discounts = populateDiscountListTable(data, this.props.offset);

            // Store data for the Area header for this table set
            if (data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.loyalty_customer) {
                    let customer = dataPayload.loyalty_customer;
                    headerSet3.id = customer.id;
                    headerSet3.first_name = customer.first_name;
                    headerSet3.last_name = customer.last_name;
                    headerSet3.email = customer.email;
                    headerSet3.telephone = customer.telephone;
                    headerSet3.city = customer.city;
                    headerSet3.state = customer.state;
                }
            }
        }

        // Finalize Discounts by VIP Account table data
        this.setState({
            allowLocationSelection: true,
            allowLoyaltySelection: true,
            errorMessage3: null,
            headerSet3: {
                id: headerSet3.id,
                first_name: headerSet3.first_name,
                last_name: headerSet3.last_name,
                email: headerSet3.email,
                telephone: headerSet3.telephone,
                city: headerSet3.city,
                state: headerSet3.state,
                zip: headerSet3.zip
            },
            loadingData3: false,
            tableSet3Discounts: tableSet3Discounts,
        });
    }

    processLocationData(id, data) {

        // Create empty arrays for selected Location ID
        let headerSet2 = {
            dba: {
                name: null
            },
            id: null,
            name: null,
            city: null,
            state: null
        };
        let tableSet2Discounts = [];
        let tableSet2Customers = [];

        // Assemble filtered data for Area 1: Discounts List
        tableSet2Discounts = populateDiscountListTable(data, this.props.offset);

        //Assemble filtered data for Area 1: VIP Customer Discount Usage Report
        tableSet2Customers = populateCustomerUsageTable(data, this.props.offset);

        if (data.aggregations) {

            // Store data for the Area header for this table set
            if (data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    headerSet2.dba = {
                        name: loc.dba.name
                    };
                    headerSet2.id = dataPayload.client.location;
                    headerSet2.name = loc.name;
                    headerSet2.city = loc.city;
                    headerSet2.state = loc.state;
                }
            }
        }

        // Finalize Discounts by Location table data
        this.setState({
            allowLocationSelection: true,
            allowLoyaltySelection: true,
            errorMessage2: null,
            headerSet2: {
                dba: {
                    name: headerSet2.dba.name
                },
                id: headerSet2.id,
                name: headerSet2.name,
                city: headerSet2.city,
                state: headerSet2.state
            },
            loadingData2: false,
            tableSet2Discounts: tableSet2Discounts,
            tableSet2Customers: tableSet2Customers
        });
    }

    /**
     * Store selected Loyalty Account and make calls
     *
     * @param event
     * @param row
     */
    handleLoyaltySelect(event, row) {
        const account = {
            id: row.id,
            first_name: row.first_name,
            last_name: row.last_name,
            email: row.email,
            telephone: row.telephone,
            city: row.city,
            state: row.state,
            zip: row.zip

        };

        this.setState({
            allowLocationSelection: false,
            allowProductSelection: false,
            allowLoyaltySelection: false,
            loadingData3: true,
            selectedLoyalty: account
        }, () => {
            this.scrollToArea(3);
            // Check totals for VIP Account before retrieving data
            this.setDataForFetch('selected_loyalty_count', account.id);
        });
    }

    /**
     * Store selected Location and make calls
     *
     * @param event
     * @param row
     */
    handleLocationSelect(event, row) {
        const location = {
            id: row.location_id,
            name: row.location_name,
            dba_name: row.dba_name,
            city: row.city,
            selected: true,
            state: row.state,
            type: 'selected',
        };
        this.setState({
            allowLocationSelection: false,
            allowProductSelection: false,
            allowLoyaltySelection: false,
            loadingData2: true,
            selectedLocation: location
        }, () => {
            this.scrollToArea(2);
            // Check totals for Location before retrieving data
            this.setDataForFetch('location_count', location.id);
        });
    }

    scrollToArea(area) {
        if (area === 2) {
            window.scrollTo(0, this.area2Position.offsetTop);
        }
        if (area === 3) {
            window.scrollTo(0, this.area3Position.offsetTop);
        }
    }

    render() {

        const {
            endDate,
            startDate,
            system
        } = this.props;

        const {
            allowLocationSelection,
            allowLoyaltySelection,
            countValid,
            dataSet1Complete,
            errorMessage1,
            errorMessage2,
            errorMessage3,
            headerSet1,
            headerSet2,
            headerSet3,
            loadingData1,
            loadingData2,
            loadingData3,
            selectedLocation,
            selectedLoyalty,
            tableSet1Discounts,
            tableSet1Locations,
            tableSet2Customers,
            tableSet2Discounts,
            tableSet3Discounts,
        } = this.state;

        let checkDate = (startDate < '2019-12-03');

        return (
            <div>

                {loadingData1 &&
                <div className="loader-container">
                    <h4>Generating Reports...</h4>
                    <CircularProgress
                        size={24}
                        thickness={2}
                        className="loader"
                    />
                </div>
                }

                {!countValid &&
                <div>
                    <div style={tableStyles.error}>
                        <p>The current filter returns too many results to display. Please edit the Date Range filter,
                            or select a different secondary filter, to reduce the total results.</p>
                    </div>
                </div>
                }

                {dataSet1Complete &&
                <div>

                    {/* Area 1: Discounts by Date Range and Secondary Filter :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef1 = e)}>
                        {/* Report Header Set 1 */}
                        <div className="report-header">
                            <div className="btn-print-container report-header-button-container">
                                <ReactToPrint
                                    trigger={() =>
                                        <RaisedButton
                                            primary
                                            type="button"
                                            label="Print Report"
                                            style={tableStyles.printBtn}/>
                                    }
                                    content={() => this.printRef1}
                                />
                            </div>
                            <h2 className="report-header-title">Discounts Report</h2>
                            {headerSet1 && headerSet1.type &&
                            <p>
                                <strong>{headerSet1.type}</strong>: {headerSet1.choice}
                            </p>
                            }
                            <p>
                                {displayDateRangeString(startDate, endDate)}<br/>
                            </p>
                            {checkDate &&
                            <div>
                                <span style={tableStyles.warning}>Warning: </span>
                                due to the implementation of saving discounts per product on 12/3/2019,
                                any calculations before this date will be inaccurate. The following areas are affected:
                                <ul>
                                    <li><strong>Discounts List</strong> - Column "Sum of Product Subtotal where Discount was Applied"
                                    </li>
                                    <li><strong>Discounts List</strong> - Column "Sum of Product Tax where Discount was Applied"
                                    </li>
                                    <li><strong>Discounts List</strong> - Column "Sum of Product Total where Discount was Applied"
                                    </li>
                                    <li><strong>Discounts List</strong> - Column "Product Qty Total where Discount was Applied"
                                    </li>
                                </ul>
                            </div>
                            }
                        </div>

                        {/* Report: Discounts by Location */}
                        <LocationDiscountsTotalsTable
                            tableFilename="Discounts-Locations"
                            tableKey="Set1"
                            tableLabel="Location Discounts Totals"
                            listData={tableSet1Locations}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                            allowLocationSelection={allowLocationSelection}
                            locationIconFunction={this.handleLocationSelect}
                        />

                        {/* Report: Discounts List */}
                        <DiscountsListTable
                            tableFilename="Discounts-List"
                            tableKey="Set1"
                            tableLabel="Discounts List"
                            listData={tableSet1Discounts}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                        />
                    </div>

                    {/* Area 2: Discounts by Selected Location :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef2 = e)}>
                        <div ref={(ref) => this.area2Position = ref}>
                        </div>

                        {selectedLocation.id && countValid && loadingData2 &&
                        <div className="loader-container">
                            <h4>Generating Reports...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                className="loader"
                            />
                        </div>
                        }
                        {!countValid &&
                        <div>
                            <div style={tableStyles.error}>
                                <p>The selected Location has too many results.
                                    Please edit the Date Range filter to reduce the total results.</p>
                            </div>
                        </div>
                        }

                        {(tableSet2Discounts.length > 0) &&
                        <div className="margin-top">

                            {/* Report Header Set 2 */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={tableStyles.printBtn}/>
                                        }
                                        content={() => this.printRef2}
                                    />
                                </div>
                                <h2 className="report-header-title">{headerSet2.id} Discounts Report</h2>
                                {headerSet2 && headerSet2.id && headerSet2.name &&
                                <p>
                                    <strong>Location Name</strong>: {headerSet2.name}<br/>
                                    {headerSet2.city &&
                                    <span>{headerSet2.city}, </span>
                                    }
                                    {headerSet2.state &&
                                    <span>{headerSet2.state}</span>
                                    }
                                </p>
                                }
                                <p>
                                    {displayDateRangeString(startDate, endDate)}
                                </p>
                            </div>

                            {/* Report: Discounts List */}
                            {tableSet2Discounts.length > 0 &&
                            <DiscountsListTable
                                tableFilename="Discounts-List"
                                tableKey="Set2"
                                tableLabel="Discounts List"
                                listData={tableSet2Discounts}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }

                            {/* Report: VIP Customers (by selected Location) */}
                            {tableSet2Customers.length > 0 &&
                            <DiscountsVipCostumerTable
                                tableFilename="VIP-Customer-List"
                                tableKey="Set2"
                                tableLabel="VIP Customer List"
                                listData={tableSet2Customers}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                                allowLoyaltySelection={allowLoyaltySelection}
                                loyaltyIconFunction={this.handleLoyaltySelect}
                            />
                            }
                        </div>
                        }
                    </div>

                    {/* Error and Messaging for set 2: Discounts by Selected Location */}
                    {errorMessage2 &&
                        <div className="error">
                            <p>{errorMessage2}</p>
                        </div>
                    }

                    {/* Area 3: Discounts by Selected VIP Account :::::::::::::::::::::::::::::::::::::::: */}
                    <div ref={e => (this.printRef3 = e)}>
                        <div ref={(ref) => this.area3Position = ref}>
                        </div>

                        {selectedLoyalty.id && countValid && loadingData3 &&
                        <div className="loader-container">
                            <h4>Generating Reports...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                className="loader"
                            />
                        </div>
                        }
                        {!countValid &&
                        <div>
                            <div style={tableStyles.error}>
                                <p>The selected VIP Account has too many results.
                                    Please edit the Date Range filter to reduce the total results.</p>
                            </div>
                        </div>
                        }

                        {(tableSet3Discounts.length > 0) &&
                        <div className="margin-top">

                            {/* Report Header Set 3 */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={tableStyles.printBtn}/>
                                        }
                                        content={() => this.printRef3}
                                    />
                                </div>
                                <h2 className="report-header-title">{headerSet3.id} Discounts Report</h2>
                                {headerSet3 && headerSet3.id &&
                                <p>
                                    <strong>First
                                        Name:</strong> {headerSet3.first_name ? headerSet3.first_name : '(None)'}<br/>
                                    <strong>Last Name:</strong> {headerSet3.last_name ? headerSet3.last_name : '(None)'}<br/>
                                    <strong>Email:</strong> {headerSet3.email ? headerSet3.email : '(None)'}<br/>
                                    <strong>Phone
                                        Number:</strong> {headerSet3.telephone ? headerSet3.telephone : '(None)'}<br/>
                                    <strong>City:</strong> {headerSet3.city ? headerSet3.city : '(None)'}<br/>
                                    <strong>State:</strong> {headerSet3.state ? headerSet3.state : '(None)'}<br/>
                                    <strong>Zipcode:</strong> {headerSet3.zip ? headerSet3.zip : '(None)'}<br/>
                                </p>
                                }
                            </div>

                            {/* Report: Discounts List */}
                            {tableSet3Discounts.length > 0 &&
                            <DiscountsListTable
                                tableFilename="Discounts-List"
                                tableKey="Set3"
                                tableLabel="Discounts List"
                                listData={tableSet3Discounts}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }
                        </div>
                        }
                    </div>

                    {/* Error and Messaging for set 3: Discounts by Selected VIP Account */}
                    {errorMessage3 &&
                        <div className="error">
                            <p>{errorMessage3}</p>
                        </div>
                    }
                </div>
                }

                {/* Error and Messaging for set 1: Discounts by Date Range and Secondary Filter */}
                {errorMessage1 &&
                    <div className="error">
                        <p>{errorMessage1}</p>
                    </div>
                }
            </div>
        )
    }
}

DiscountsReportSet.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    filterChoiceFirst: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterChoiceSecond: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterType: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDataProcessed: PropTypes.func,
    showLoading: PropTypes.bool,
    startDate: PropTypes.string,
    system: PropTypes.string,
    totalFiltersAvailable: PropTypes.number,
};

DiscountsReportSet.defaultProps = {
    addField: true,
    endDate: null,
    filterChoiceFirst: null,
    filterChoiceSecond: null,
    filterType: 'all',
    offset: null,
    showLoading: false,
    startDate: null,
    totalFiltersAvailable: 0,
};

const enhance = compose(
    connect()
);

export default enhance(DiscountsReportSet);



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountsReportSet.js